import { Box, Flex, Text } from '@chakra-ui/react';
import { Badge, ButtonText } from '@morressier/alembic';
import { IAffiliationDetails } from '@publishing-engine/domain/models';
import RinggoldBadge from 'src/components/RinggoldBadge';

export type RenderAffiliationDataProps = {
  affiliation: Partial<IAffiliationDetails> | Partial<IAffiliationDetails>[];
  label: string;
  badge: string;
};

export const handleOpenUrl = (url: string) => {
  const urlWithProtocol = url.match(/^https?:\/\//) ? url : `https://${url}`;

  window.open(urlWithProtocol, '_blank', 'noopener,noreferrer');
};

export const RenderAffiliationData = ({
  affiliation,
  label,
  badge
}: RenderAffiliationDataProps) => {
  const affiliations = Array.isArray(affiliation)
    ? affiliation
    : affiliation
    ? [affiliation]
    : [];

  return (
    <Flex direction="column" gap={1}>
      <Text textStyle="headingItem">
        {label}{' '}
        <Badge
          size="context"
          variant={badge === 'Previous' ? 'neutral' : 'attention'}
        >
          {badge}
        </Badge>
      </Text>

      {affiliations.length ? (
        affiliations.map((item, index) => (
          <Flex gap={1} alignItems={'baseline'} justifyContent={'start'}>
            <Text textStyle={'headingItem'}>{`${index + 1})`}</Text>
            <Flex
              key={item?.ringgoldId ?? item?.organizationName ?? index}
              direction="column"
              gap={1}
              mt={index > 0 ? 4 : 0}
            >
              {' '}
              <Text textStyle="textBody">
                {item?.ringgoldId && <RinggoldBadge />}
                {item?.organizationName}
              </Text>
              <Text textStyle="textBody">{item?.department}</Text>
              <Text textStyle="textBody">
                {item?.streetAddress ? `${item?.streetAddress}, ` : ''}
                {item?.stateOrRegion}
              </Text>
              <Text textStyle="textBody">
                {item?.city}
                {item?.postalCode ? ` - ${item?.postalCode}` : ''}
              </Text>
              <Text textStyle="textBody">
                {item?.country}
                {item?.countryCode && ` (${item?.countryCode})`}
              </Text>
              {item?.url && (
                <Box>
                  <ButtonText
                    onClick={() => handleOpenUrl(item?.url!)}
                    whiteSpace="normal"
                    wordBreak="break-all"
                  >
                    {item?.url}
                  </ButtonText>
                </Box>
              )}
            </Flex>
          </Flex>
        ))
      ) : (
        <Text textStyle="textBody" color="GrayText">
          No data available
        </Text>
      )}
    </Flex>
  );
};
